export default [
    {
      path: '/review',
      name: 'review-read',
      component: () => import('@/views/review/review-list/ReviewList.vue'),
      meta: {
        resource: 'Reviews',
        action: 'read',
      },
    },
    {
      path: '/review/create',
      name: 'review-create',
      component: () => import('@/views/review/review-form/ReviewForm.vue'),
      meta: {
        resource: 'Reviews',
        action: 'create',
      },
    },
    {
      path: '/destination',
      name: 'destination-read',
      component: () => import('@/views/review/destination/DestinationList.vue'),
      meta: {
        resource: 'Review Destinations',
        action: 'read',
      },
    },
    {
      path: '/destination/create',
      name: 'destination-create',
      component: () => import('@/views/review/destination/DestinationForm.vue'),
      meta: {
        resource: 'Review Destinations',
        action: 'create',
      },
    }
]